// Copyright (c) 2017 Deere & Company

import Report, {getDefaultState} from '../state/report';
import actions from '../../actions-list';

const updateSpecialAllowanceClaimStatusReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

const resetSpecialAllowanceClaimStatusReport = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_SPECIAL_ALLOWANCE_CLAIM_STATUS_SUCCESS]: updateSpecialAllowanceClaimStatusReport,
        [actions.RESET_SPECIAL_ALLOWANCE_CLAIM_STATUS_REPORT]: resetSpecialAllowanceClaimStatusReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/reducers/report.js